import CloseIcon from '@mui/icons-material/Close';
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Paper, PaperProps } from '@mui/material';
import Draggable from 'react-draggable';

import { AVADialogProps } from './types';
import './AVADialog.css';

const DraggableDialogComponent = (props: PaperProps) => {
    return (
        <Draggable
            handle='#draggable-dialog-title'
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} />
        </Draggable>
    );
};

export const AVADialog = ({
    id,
    open,
    title,
    children,
    actions,
    onClose,
    width,
    maxWidth = 'md',
    dataTestId = 'dialog-component',
    draggable = true,
    backdropSx,
}: AVADialogProps) => {
    return (
        <Dialog
            data-testid={dataTestId || 'muiDialog'}
            id={id}
            className='muiDialog'
            disableEnforceFocus={true}
            open={Boolean(open)}
            maxWidth={maxWidth}
            slotProps={{
                backdrop: {
                    sx: {
                        ...backdropSx,
                    },
                },
            }}
            PaperProps={{
                sx: {
                    width: width,
                    maxWidth: maxWidth || '100%',
                },
            }}
            fullWidth
            PaperComponent={draggable ? DraggableDialogComponent : undefined}
        >
            <DialogTitle
                className='popup-header-mui'
                id={draggable ? 'draggable-dialog-title' : undefined}
                sx={{
                    color: 'white',
                    marginBottom: '1rem',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderradius: '0 0 4px 4px',
                    // change cursor to move when draggable
                    cursor: draggable ? 'move' : 'default',
                }}
            >
                {title}
                <IconButton onClick={onClose} aria-label='close-avadialog-button'>
                    <CloseIcon style={{ color: 'white', fill: 'white' }} />
                </IconButton>
            </DialogTitle>
            <DialogContent>{children}</DialogContent>
            {actions && <DialogActions sx={{ backgroundColor: '#fff' }}>{actions}</DialogActions>}
        </Dialog>
    );
};
